import * as angular from 'angular';

import { ComponentDefinition, Pattern, IUserProperties } from '../../models';

class UserSearchBarController implements angular.IComponentController {
    criteria: Pattern<IUserProperties>[];
    filteredItems: IUserProperties[];
    items: IUserProperties[];

    static $inject = [];

    $onInit() {
        this.criteria = [
            {
                label: 'User name',
                placeholder: 'Search pattern on user name',
                property: 'u',
                model: 'u',
                isMatch: (d, regex, original) => {
                    return regex.test(d.displayName) || regex.test(d.name) || regex.test(d.userName);
                }
            },
            {
                label: 'Email',
                placeholder: 'Search pattern on email',
                property: 'em',
                model: 'em',
                isMatch: (d, regex, original) => {
                    return regex.test(d.email);
                }
            },
            {
                label: 'Company',
                placeholder: 'Search pattern on company',
                property: 'co',
                model: 'co',
                isMatch: (d, regex, original) => {
                    return regex.test(d.company);
                }
            },
            {
                label: 'Super administrator',
                placeholder: 'yes, y, true',
                property: 'sa',
                model: 'sa',
                isMatch: (d, regex, original) => {
                    const truthy = ['yes', 'y', 'true'];
                    const falsy = ['no', 'n', 'false'];
                    const hasSuperAdmin = d.isSuperAdmin;
                    if (truthy.filter(t => regex.test(t)).length > 0) {
                        return hasSuperAdmin;
                    } else if (falsy.filter(t => regex.test(t)).length > 0) {
                        return !hasSuperAdmin;
                    } else {
                        return false;
                    }
                }
            }
        ];
    }
}

export const wtUserSearchBar: ComponentDefinition = {
    componentId: 'wtUserSearchBar',
    controller: UserSearchBarController,
    template: require('./userSearchBar.component.html'),
    controllerAs: 'vm',
    bindings: {
        items: '<',
        filteredItems: '='
    }
};
